// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/image/icon/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
  min-height: calc(var(--vh, 1vh) * 100);
  position: relative;
}

.signup-bg {
  background-color: #000;
  width: 100%;
  height: 100%;
  position: absolute;
}

.signup-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.signup-box-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / cover;
  width: 100%;
  height: 100%;
}

.signup-box {
  max-width: 430px;
  min-height: 100vh;
  /* position: absolute; */
  /* left: 50%; */
  /* top: 0; */
  /* transform: translateX(-50%); */
  /* z-index: 99; */
  /* width: 100%; */
  background-color: #fff;
  opacity: 0.99;
  padding: 60px 4.5rem;
}

.login-box {
  max-width: 430px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 99;
  width: 100%;
}

.signup-content-container {
  background-color: rgba(129, 105, 105, 0.9);
  padding: 1rem 4.5rem;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  /* height: 100vh; */
  overflow-y: auto;
  padding-top: 134px;
}

.login-content-container {
  background-color: rgba(255, 255, 255, 1);
  padding: 1rem 4.5rem;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: auto;
  padding-top: 134px;
}

.floating-container .form-floating {
  color: #999;
}

.floating-container .form-control {
  height: 40px;
  min-height: initial;
  border-radius: 3px;
}

.floating-container .form-control,
.floating-container .form-control::placeholder {
  font-weight: 700 !important;
}

.form-floating .form-control,
.form-floating label {
  padding: 0.45rem;
}

.form-floating label {
  line-height: 2;
  font-weight: 700;
}

.signup-box-bg .form-floating label {
  font-weight: 400 !important;
}

.floating-container .form-control,
.floating-container select {
  background-color: transparent;
  border: 1px solid #999;
}

.form-floating select {
  padding-top: 1.15rem !important;
  padding-bottom: 0.45rem !important;
  min-height: initial !important;
  height: 40px !important;
  border-radius: 3px;
  padding-left: 0.45rem !important;
}

.floating-container label::after {
  background-color: transparent !important;
}

.floating-container .form-control:focus,
.floating-container select:focus {
  box-shadow: none;
  border: 1px solid #961d4c;
}

.floating-container .form-control:focus ~ label {
  color: #961d4c;
}

.floatingEye {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}

.sign-label {
  width: 19px;
  height: 19px;
  border-radius: 1px;
  border: 1px solid #999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.terms-gray {
  color: #999;
}

.signup-btn {
  background-color: #961d4c;
  padding: 0.45rem;
  border-radius: 3px;
}

.email-check-btn {
  background-color: #961d4c;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 3px;
  height: 40px;
  line-height: 40px;
}

@media (max-width: 429px) {
  .login-content-container,
  .signup-box {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (max-height: 850px) {
  .signup-box {
    padding-top: 30px;
    padding-bottom: 30px;
    min-height: 100vh;
  }
}

.red {
  color: #ff0000;
}

.password-modal .modal-dialog {
  max-width: 500px;
}

.signup-logo {
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/signup.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4EAA6E;EAC7E,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".signup-container {\n  min-height: calc(var(--vh, 1vh) * 100);\n  position: relative;\n}\n\n.signup-bg {\n  background-color: #000;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.signup-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.signup-box-bg {\n  background: url('../../../public/image/icon/bg.png') no-repeat center / cover;\n  width: 100%;\n  height: 100%;\n}\n\n.signup-box {\n  max-width: 430px;\n  min-height: 100vh;\n  /* position: absolute; */\n  /* left: 50%; */\n  /* top: 0; */\n  /* transform: translateX(-50%); */\n  /* z-index: 99; */\n  /* width: 100%; */\n  background-color: #fff;\n  opacity: 0.99;\n  padding: 60px 4.5rem;\n}\n\n.login-box {\n  max-width: 430px;\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  z-index: 99;\n  width: 100%;\n}\n\n.signup-content-container {\n  background-color: rgba(129, 105, 105, 0.9);\n  padding: 1rem 4.5rem;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n  /* height: 100vh; */\n  overflow-y: auto;\n  padding-top: 134px;\n}\n\n.login-content-container {\n  background-color: rgba(255, 255, 255, 1);\n  padding: 1rem 4.5rem;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n  height: calc(var(--vh, 1vh) * 100);\n  overflow-y: auto;\n  padding-top: 134px;\n}\n\n.floating-container .form-floating {\n  color: #999;\n}\n\n.floating-container .form-control {\n  height: 40px;\n  min-height: initial;\n  border-radius: 3px;\n}\n\n.floating-container .form-control,\n.floating-container .form-control::placeholder {\n  font-weight: 700 !important;\n}\n\n.form-floating .form-control,\n.form-floating label {\n  padding: 0.45rem;\n}\n\n.form-floating label {\n  line-height: 2;\n  font-weight: 700;\n}\n\n.signup-box-bg .form-floating label {\n  font-weight: 400 !important;\n}\n\n.floating-container .form-control,\n.floating-container select {\n  background-color: transparent;\n  border: 1px solid #999;\n}\n\n.form-floating select {\n  padding-top: 1.15rem !important;\n  padding-bottom: 0.45rem !important;\n  min-height: initial !important;\n  height: 40px !important;\n  border-radius: 3px;\n  padding-left: 0.45rem !important;\n}\n\n.floating-container label::after {\n  background-color: transparent !important;\n}\n\n.floating-container .form-control:focus,\n.floating-container select:focus {\n  box-shadow: none;\n  border: 1px solid #961d4c;\n}\n\n.floating-container .form-control:focus ~ label {\n  color: #961d4c;\n}\n\n.floatingEye {\n  position: absolute;\n  top: 50%;\n  right: 0.75rem;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n}\n\n.sign-label {\n  width: 19px;\n  height: 19px;\n  border-radius: 1px;\n  border: 1px solid #999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.terms-gray {\n  color: #999;\n}\n\n.signup-btn {\n  background-color: #961d4c;\n  padding: 0.45rem;\n  border-radius: 3px;\n}\n\n.email-check-btn {\n  background-color: #961d4c;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 3px;\n  height: 40px;\n  line-height: 40px;\n}\n\n@media (max-width: 429px) {\n  .login-content-container,\n  .signup-box {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (max-height: 850px) {\n  .signup-box {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    min-height: 100vh;\n  }\n}\n\n.red {\n  color: #ff0000;\n}\n\n.password-modal .modal-dialog {\n  max-width: 500px;\n}\n\n.signup-logo {\n  width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
